/**
 * @author Joe Adcock <joe@d3r.com>
 */

$.fn.radioStyle = function() {
    $(this).each(function() {
        var current = $(this);
        current.wrap('<div class="radio-style"></div>').hide();

        var wrap = $(this).parent();

        wrap.append('<div class="radio-style__indicator"></div>');
    });
};
